export default [
    'ShoppingCart.refreshCount',
    'ShoppingCart.persist',
    'ShoppingCart.persistState',
    'ShoppingCart.selectedPlansMap0',
    'SignUp.account',
    'SignUp.zuoraInfo',
    'SignUp.agreements',
    'ShoppingCart.currentEditPlan',
    'Coupon.couponState',
    'Coupon.verifyCouponStatus',
    'Coupon.supportCouponState',
    'SmsVerify.verificationDetail',
    'ShoppingCart._healthcareInfo',
    'SignUp.lookupInfo',
    'ShoppingCart.trialInfoMap',
    'ShoppingCart.draftPlanFilterKeys',
];
